import React from 'react';
import CompletedItem from '../completed-item/CompletedItem';
import {useState} from 'react'
import upImg from 'assets/img/up.svg'
import './completed-list.scss'
import { Button, IconButton } from 'material-ui';
import ShowMoreButton from 'ui-components/ShowMoreButton';
import UpButton from 'ui-components/UpButton';
import GroupedTasks from '../grouped-tasks/GroupedTasks';

const CompletedList = () => {
    const [itemsToShow, setItems] = useState(1)
    
    const tasks = [
        {
            date: 'Jan 1, 2022',
            items: [
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Sergey Moshko", date: "Jan 31, 2022", type: "Remote"},
                {id: 3, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 4, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 5, name: "Helena igez", date: "Jan 31, 2022", type: "Remote"},
                {id: 6, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 7, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 8, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 9, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 10, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 11, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
            ]
        },
        {
            date: 'Jan 3, 2022',
            items: [
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Sergey Moshko", date: "Jan 31, 2022", type: "Remote"},
                {id: 3, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 4, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 5, name: "Helena igez", date: "Jan 31, 2022", type: "Remote"},
                {id: 6, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 7, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 8, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 9, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 10, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 11, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
            ]
        },
        {
            date: 'Jan 4, 2022',
            items: [
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Sergey Moshko", date: "Jan 31, 2022", type: "Remote"},
                {id: 3, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 4, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 5, name: "Helena igez", date: "Jan 31, 2022", type: "Remote"},
                {id: 6, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 7, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 8, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 9, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 10, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 11, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
            ]
        },
        {
            date: 'Jan 6, 2022',
            items: [
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Sergey Moshko", date: "Jan 31, 2022", type: "Remote"},
                {id: 3, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 4, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 5, name: "Helena igez", date: "Jan 31, 2022", type: "Remote"},
                {id: 6, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 7, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 8, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 9, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 10, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 11, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 1, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
                {id: 2, name: "Helena Rodrigez", date: "Jan 31, 2022", type: "Remote"},
            ]
        }
    ]

    const buttonHandler = () => {
        setItems(prev => prev + 1)
    }

    const collapseHandler = () => {
        setItems(1)
    }
    const tasksToShow = tasks.slice(0, itemsToShow)
    return (
        <div className="completed-list">
           
            {
                tasksToShow.map((group, i) => (
                    <GroupedTasks
                        key={i}
                        date={group.date}
                        items={group.items}
                    />
                ))
            }
            <ShowMoreButton
                onClick={buttonHandler}
            />
            {
                itemsToShow > 1 && 
                   <UpButton 
                        onClick={collapseHandler}
                    />
            }
        </div>
    );
};

export default CompletedList;